export function toTitleCase(str: string) {
  const title = str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Convert camelCase to space-separated words
    .replace(/_/g, ' ') // Convert snake_case to space-separated words
    .replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });

  return newTitle(title);
}

function newTitle(str: string) {
  if(str === 'Proses Kehadiran Makan Siang') {
    return 'Kehadiran & Order Makan Siang';
  }

  if(str === 'Pemantauan Kpiharian') {
    return 'Pemantauan KPI Harian';
  }

  if(str === 'Pengajuan Beasiswa') {
    return 'Pengajuan Beasiswa';
  }

  if(str === 'Pengajuan Lembur') {
    return 'Pengajuan Lembur';
  }

  if(str === 'Pengajuan Loan') {
    return 'Pengajuan Loan';
  }

  if(str === 'Pengajuan Payroll Bonus') {
    return 'Pengajuan Payroll & Bonus';
  }

  if(str === 'Pengajuan Perjalanan Dinas') {
    return 'Pengajuan Perjalanan Dinas';
  }

  if(str === 'Pengajuan Reimburse') {
    return 'Pengajuan Reimburse';
  }

  if(str === 'Proses Pengajuan Cuti Ciomy') {
    return 'Proses Pengajuan Cuti';
  }

  return str;
}